import SharedHeader from '@/components/share/header'
import AllConversations from '@/graphql/chat/queries/all-conversations.query'
import OnConversation from '@/graphql/chat/subscriptions/on-conversation.subscription'
import ChatDetail from '@/components/chat/detail'
import Message from '@/graphql/chat/queries/message.query'

export default {
  name: 'chat',
  components: {
    SharedHeader,
    ChatDetail
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    avatar () {
      return this.$store.getters.avatar
    },
    env () {
      return this.$store.getters.env
    },
    sortedItems () {
      let isOkay = true
      for (let i in this.allConversations.items) {
        if (this.allConversations.items[i].userType !== 'ENTERPRISE') isOkay = false
      }

      if (isOkay) {
        this.localeRooms = this.allConversations.items.sort((a, b) => {
          return (new Date(a.createdAt) > new Date(b.createdAt)) ? -1 : (new Date(a.createdAt) < new Date(b.createdAt)) ? 1 : 0
        })
        return this.localeRooms
      } else {
        return this.localeRooms
      }
    },
    room () {
      if (this.$route.query.id) {
        for (let i in this.allConversations.items) {
          if (this.allConversations.items[i].id === this.$route.query.id &&
              this.allConversations.items[i].userType === 'ENTERPRISE'
          ) {
            this.localeRoom = this.allConversations.items[i]
            return this.allConversations.items[i]
          } else if (this.allConversations.items[i].id === this.$route.query.id &&
              this.allConversations.items[i].userType === 'STUDENT') {
            return this.localeRoom
          }
        }
      }
    }
  },
  data () {
    return {
      roomsPagination: {
        loading: false,
        nextToken: ''
      },
      allConversations: {
        items: []
      },
      selected: '',
      loading: false,
      localeRoom: {},
      localeRooms: []
    }
  },
  methods: {
    getAvatar (avatarId) {
      return `${this.env.S3}/student/avatar/${avatarId}.png`
    },
    setRoom (item) {
      this.selected = item.id
      this.$router.push({
        query: {
          id: item.id
        }
      })
    },
    getDate (utcString) {
      let dt = new Date(utcString)
      return `${dt.getFullYear()}/${dt.getMonth() + 1}/${dt.getDate()} ${dt.getHours()}:${dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes()}`
    },
    updateUnreadCount () {
      for (let i in this.allConversations.items) {
        if (this.allConversations.items[i].id === this.room.id) this.allConversations.items[i].unreads = 0
      }
    },
    async getRoomLastMessage (room) {
      if (room.lastMessageId) {
        const messageResponse = await this.$apollo.query({
          query: Message,
          fetchPolicy: 'network-only',
          variables: {
            id: room.lastMessageId
          }
        })

        return messageResponse.data.message
      }
    }
  },
  async mounted () {
    if (this.$route.query.id) this.selected = this.$route.query.id

    this.$apollo.queries.allConversations.subscribeToMore({
      document: OnConversation,
      variables: {
        userId: this.user.enterpriseId
      },
      updateQuery: async (previousResult, { subscriptionData: { data } }) => {
        if (data.userType !== 'ENTERPRISE') {
          for (let i in previousResult.allConversations.items) {
            if (previousResult.allConversations.items[i].id === data.onConversation.id) {
              previousResult.allConversations.items[i].lastMessage = await this.getRoomLastMessage(data.onConversation)
              return previousResult
            }
          }
        }
      }
    })
  },
  watch: {
    $route (to, from) {
      if (to.query.id) this.selected = this.$route.query.id
    }
  },
  apollo: {
    allConversations: {
      query: () => AllConversations,
      fetchPolicy: 'network-only',
      variables () {
        return {
          userId: this.user.enterpriseId
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/chat/chat.js